<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="backToList">
                        <img src="@/assets/backPage.png" style="width: 100%" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <div id="stress_layer">
                    <div class="stress_box">
                        <div class="stress_tit">
                            <p class="time">{{ state.data.hour }}시</p>
                            <p class="tit">{{ state.title }}</p>
                        </div>
                        <div class="stress_number">
                            <div class="stress_bar">
                                <VueSlider v-model="state.value" />
                                <div class="stress_bar_count">
                                    <b>0</b>
                                    <b>50</b>
                                    <b>100</b>
                                </div>
                            </div>
                        </div>
                        <div class="stress_result">
                            <b>{{ state.value }}</b>점
                        </div>
                        <div class="stress_tit">
                            <br />
                            <p class="tit">{{ state.title2 }}</p>
                        </div>
                        <div class="stress_number">
                            <div class="stress_bar">
                                <VueSlider v-model="state.value2" class="slider_red" />
                                <div class="stress_bar_count">
                                    <b>0</b>
                                    <b>50</b>
                                    <b>100</b>
                                </div>
                            </div>
                        </div>
                        <div class="stress_result">
                            <b>{{ state.value2 }}</b>점
                        </div>
                        <div class="stress_tit" v-if="state.isShowbox">
                            <br />
                            <p class="tit">{{ state.title3 }}</p>
                        </div>
                        <div class="stress_number" v-if="state.isShowbox">
                            <div class="stress_bar">
                                <VueSlider v-model="state.value3" class="slider_purple" />
                                <div class="stress_bar_count">
                                    <b>0</b>
                                    <b>50</b>
                                    <b>100</b>
                                </div>
                            </div>
                        </div>
                        <div class="stress_result" v-if="state.isShowbox">
                            <b>{{ state.value3 }}</b>점
                        </div>
                    </div>
                    <button type="button" class="submit_btn" @click="submitPoint">제출하기</button>
                </div>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose">
    </ModalComponent>
</template>
<script lang="ts" config>
import { ModalComponent, apiService, dateFormat, onMounted, reactive, router } from "@/BaseComponent";
import VueSlider from "vue-3-slider-component";
import "../../../public/css/style_test.css";
export default {
    components: {
        VueSlider,
        ModalComponent,
    },
    setup() {
        const state = reactive({
            title: "스트레스 점수",
            title2: "피로도 점수",
            title3: "수면 점수",
            value: 50 as number,
            value2: 50 as number,
            value3: 50 as number,
            selectTime: 0 as number,
            isModalOpen: false as boolean,
            isShowbox: true as boolean,
            data: "" as any,
        });

        const modal = reactive({
            confirm: "" as string,
            cancel: "" as string,
            content: "" as string,
        });

        onMounted(() => {
            if (history.state != null || history.state != undefined) {
                state.data = history.state;
                if (history.state.content) {
                    state.value = history.state.content;
                }
                if (history.state.content2) {
                    state.value2 = history.state.content2;
                }
                if (history.state.content3) {
                    state.value3 = history.state.content3;
                }
            }
            if (state.data.idx !== 0 || state.data.hour === 2) {
                state.isShowbox = false;
            }
        });

        const submitStressValue = async () => {
            const res = await apiService.base.addVasSurvey(
                state.value.toString(),
                state.value2.toString(),
                state.value3.toString(),
                state.data.date,
                state.data.idx + 1,
                state.data.token,
            );
            if (res.returnCode === 0) {
                modal.content = "제출이 완료되었습니다.";
                modal.confirm = "확인";
                modal.cancel = "";
                state.isModalOpen = true;
            } else {
                modal.content = res.description;
                modal.confirm = "";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const backToList = () => {
            router.back();
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                if (modal.content === "제출하시겠습니까?") {
                    submitStressValue();
                } else if (modal.content === "제출이 완료되었습니다.") {
                    router.back();
                }
            }
        };
        const submitPoint = () => {
            const nowDate = new Date();
            if (state.data.date === dateFormat(new Date()) || state.data.date === dateFormat(new Date(nowDate.setDate(nowDate.getDate() - 1)))) {
                modal.content = "제출하시겠습니까?";
                modal.confirm = "확인";
                modal.cancel = "취소";
                state.isModalOpen = true;
            } else {
                modal.content = "당일 또는 전날 설문만 수정이 가능합니다.";
                modal.confirm = "";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };
        return {
            state,
            modal,
            backToList,
            modalClose,
            submitPoint,
        };
    },
};
</script>
<style>
.vue-slider {
    width: 100%;
    height: 15px !important;
}

.vue-slider .vue-slider-filled {
    height: 100%;
    background-color: #4caf50;
}

.vue-slider .vue-slider-handle {
    width: 16px;
    height: 16px;
    background-color: #4caf50;
    border: 2px solid #4caf50;
    box-sizing: border-box;
    margin-top: -5px;
}

.vue-slider-rail {
    background-color: #f1f1f1 !important;
}

.vue-slider-dot {
    width: 30px !important;
    height: 30px !important;
    z-index: 1;
}

.vue-slider-dot-handle {
    background-color: var(--blue) !important;
    border: 3px solid #fff !important;
}

.vue-slider-process {
    background-color: var(--blue) !important;
}

.vue-slider-dot-tooltip-inner {
    background-color: var(--blue) !important;
    border-color: var(--blue) !important;
}

.vue-slider-dot-tooltip-inner span {
    color: #fff !important;
}

.vue-slider-dot-handle-focus {
    box-shadow: 0.5px 0.5px 2px 1px #00000052 !important;
}

.slider_red .vue-slider-dot-handle {
    background-color: var(--red) !important;
    border: 3px solid #fff !important;
}

.slider_red .vue-slider-process {
    background-color: var(--red) !important;
}

.slider_red .vue-slider-dot-tooltip-inner {
    background-color: var(--red) !important;
    border-color: var(--red) !important;
}

.slider_purple .vue-slider-dot-handle {
    background-color: rgb(137, 98, 248) !important;
    border: 3px solid #fff !important;
}

.slider_purple .vue-slider-process {
    background-color: rgb(137, 98, 248) !important;
}

.slider_purple .vue-slider-dot-tooltip-inner {
    background-color: rgb(137, 98, 248) !important;
    border-color: rgb(137, 98, 248) !important;
}
</style>
